import React from 'react'

import { applyStyle, getSmartSize } from '../helpers/styles'
import { useColor } from '../../components/theme/_hooks/colors'

export const useBorderStyle = props => {
  let {
    radius,
    noRadius,
    noRadiusBottom,
    noRadiusTop,
    borderColor,
    borderLeftColor,
    borderWidth,
    borderLeftWidth,
    borderStyle,
    borderLeftStyle,
    noBorder
  } = props
  const borderColorValue = useColor(borderColor)
  const borderLeftColorValue = useColor(borderLeftColor)

  borderWidth = borderWidth || (borderColorValue ? '1px' : borderWidth)
  borderLeftWidth = borderLeftWidth || borderWidth || (borderLeftColorValue ? '5px' : borderWidth)
  borderStyle = borderStyle || (borderColorValue ? 'solid' : borderStyle)
  borderLeftStyle = borderLeftStyle || (borderLeftColorValue ? 'solid' : borderLeftStyle)

  return React.useMemo(() => {
    return `
			border: none;
      ${applyStyle('border-width', borderWidth, getSmartSize(borderWidth))}
      ${applyStyle('border-width', noBorder, '0px')}
      ${applyStyle('border-left-width', !noBorder && borderLeftWidth, getSmartSize(borderLeftWidth))}
      ${applyStyle('border-color', borderColorValue)}
      ${applyStyle('border-left-color', borderLeftColorValue)}
      ${applyStyle('border-style', borderStyle)}
      ${applyStyle('border-left-style', borderLeftStyle)}
      ${applyStyle('border-radius', radius, getSmartSize(radius))}
      ${applyStyle('border-radius', noRadius, 0)}
      ${applyStyle('border-bottom-left-radius', noRadiusBottom, 0)}
      ${applyStyle('border-bottom-right-radius', noRadiusBottom, 0)}
      ${applyStyle('border-top-left-radius', noRadiusTop, 0)}
      ${applyStyle('border-top-right-radius', noRadiusTop, 0)}
    `
  }, [
    radius,
    noRadiusBottom,
    noRadiusTop,
    borderColorValue,
    borderWidth,
    borderStyle,
    noBorder,
    borderLeftColorValue,
    borderLeftWidth,
    borderLeftStyle,
    noRadius
  ])
}
